// extracted by mini-css-extract-plugin
module.exports = {"item":"ColorLegend_item__2MCER","colorBox":"ColorLegend_colorBox__1e42b"};